import { LEAD_QUIZZES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const leadQuizzesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getLeadQuizzes: build.query({
      query: (params = {}) => ({
        url: LEAD_QUIZZES.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('LeadQuiz', result),
    }),
    getLeadQuizById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: LEAD_QUIZZES.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'LeadQuiz',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createLeadQuiz: build.mutation({
      query: (arg) => {
        const isWrapped =
          arg &&
          typeof arg === 'object' &&
          !(arg instanceof FormData) &&
          ('data' in arg || 'params' in arg);
        const payload = isWrapped ? arg.data : arg;
        const params = isWrapped ? arg.params : undefined;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: LEAD_QUIZZES.LIST,
          method: 'POST',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'LeadQuiz', id: 'LIST' }],
    }),
    updateLeadQuiz: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: LEAD_QUIZZES.BY_ID(id),
          method: 'PUT',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'LeadQuiz', id },
        { type: 'LeadQuiz', id: 'LIST' },
      ],
    }),
    deleteLeadQuiz: build.mutation({
      query: (id) => ({ url: LEAD_QUIZZES.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'LeadQuiz', id },
        { type: 'LeadQuiz', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetLeadQuizzesQuery,
  useLazyGetLeadQuizzesQuery,
  useGetLeadQuizByIdQuery,
  useLazyGetLeadQuizByIdQuery,
  useCreateLeadQuizMutation,
  useUpdateLeadQuizMutation,
  useDeleteLeadQuizMutation,
} = leadQuizzesApi;
